// --- Dependencies -------------------------------------------------------------------------------
import { type ReactNode, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import useAuth from "@/hooks/useAuth";
import AppBar from "@/UI/components/AppBar";
import BottomBar from "@/UI/components/BottomBar";
import SideBar from "@/UI/components/SideBar";
import "./styles.css";

// --- Logic --------------------------------------------------------------------------------------

type Props = {
    children?: ReactNode;
};

/** One gate, not two — there is no store to select after signing in the way `clients-web` has. */
export default function DashboardLayout({ children }: Props = {}) {
    const token = useAuth((state) => state.token);
    const { pathname } = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        setIsMenuOpen(false);
    }, [pathname]);

    if (!token) return <Navigate to="/login" replace />;

    return (
        <div className="dashboard-layout">
            <SideBar isOpen={isMenuOpen} />
            {isMenuOpen && <div className="dashboard-overlay" onClick={() => setIsMenuOpen(false)} />}
            <div className="dashboard-content">
                <AppBar onMenuClick={() => setIsMenuOpen((prev) => !prev)} />
                <main className="dashboard-main">{children ?? <Outlet />}</main>
            </div>
            <BottomBar />
        </div>
    );
}
